<template>
    <div class="testimonial">
        <div class="testimonial__portrait" :style="{ backgroundImage: 'url(' + require(`../../assets/${portrait}.jpg`) + ')' }"></div>
        <span class="testimonial__name">{{ name }}</span>
        <span class="testimonial__company">{{ company }}</span>
        <div class="testimonial__text">{{ text }}</div>
    </div>
</template>

<script>
    export default {
        name: 'Testimonial',
        props: {
            portrait: String,
            name: String,
            company: String,
            text: String
        }
    }
</script>

<style lang="scss" scoped>

    .testimonial {
        width: 100%;
        text-align: center;

        &__portrait {
            width: 16rem;
            height: 16rem;
            border-radius: 50%;
            margin: 0 auto;
            background-color: #f0f0f0;
            background-size: cover;
            background-position: center center;
            box-shadow: 10px -10px #fad2ca54, -10px 10px #375dad29;
        }

        &__name {
            display: block;
            width: 100%;
            margin-top: 3rem;
            font-family: 'Roboto Slab', sans-serif;
            font-size: 2rem;
            font-weight: 600;
        }

        &__company {
            display: block;
            width: 100%;
            margin-top: .5rem;
            font-size: 1.4rem;
            font-weight: 600;
            color: #666;
        }

        &__text {
            position: relative;
            margin-top: 6rem;
            line-height: 1.6;
            color: #666;

            &::before {
                position: absolute;
                top: -3rem;
                left: 35%;
                display: block;
                width: 30%;
                height: .3rem;
                background-color: #fad2ca;
                content: "";
            }
        }
    }

    @media (min-width: 768px) and (max-width: 999px) {

        .testimonial__text {
            font-size: 1.4rem;
        }
    }

</style>